export default "__VITE_ASSET__67AR5G28__"